export default "__VITE_ASSET__03519010__"